import BackButtonPage from '../../../../../components/BackButtonPage';

function DunaiHajok() {
  return (
    <div className='page-content-container'>
        <img src="/assets/duna_hajok.png" className='responsive-img' alt="Ábrázolások 1" />
        <BackButtonPage to="/hajokrol" />
    </div>
  );
}

export default DunaiHajok;
